import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { URLS } from '../constants/URLS';
import { ApiService } from './api.service';
import { AuthenticateserviceService } from './authenticateservice.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  downloadedVideos = [];

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
    private universalApi: ApiService,
    private authService: AuthenticateserviceService
  ) { }

  sectionsdata(channel_id) {
    let body = new URLSearchParams();
    body.set('start_index', '0');
    body.set('last_index', '20');
    // body.set('channel_id', '10750');
    return this.universalApi.postFormWithStatusCheck(URLS.getSectionsContent, body.toString()).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  getPrimeVideo(vidLibId) {
    let body = new URLSearchParams();
    body.set('video_type', 'premium');
    body.set('vidLibList', vidLibId);
    return this.universalApi.postForm(URLS.getSectionsContent, body.toString()).pipe(
      map(responseData => {
        if (responseData.status === '0' || responseData.status === 0) {
          return { data: responseData.data }; 
        } else {
          throw new Error(responseData.message || 'API request failed');
        }
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  getTotalSeries(){

  }

  sectionsByCategoryId(categoryId, startIndex, lastIndex): Observable<any> {
    let body = new URLSearchParams();
    body.set('start_index', startIndex);
    body.set('last_index', lastIndex);
    body.set('category_id', categoryId);
    return this.universalApi.postFormWithStatusCheck(URLS.getSectionContentById, body.toString()).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ) as Observable<Comment[]>;
  }

  public downloadVideo(filePath: string): Observable<Blob> {
    return this.http.get(filePath, {
      responseType: 'blob'
    });
  }

  getChannelInfoById() {
    let body = new URLSearchParams();
    body.set('start_index', '1');
    body.set('last_index', '20');
    body.set('channel', '43');
    return this.universalApi.postFormWithStatusCheck(URLS.getSectionsContent, body.toString()).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  getChannelInfoByUserId() {
    var userId: String;
    userId = localStorage.getItem("userId");
    const bodyReq = { 'userId': userId };
    return this.universalApi.postWithResponseCode(URLS.getAllChannelInfo, bodyReq).pipe(
      map(responseData => {
        localStorage.setItem('channelData', JSON.stringify(responseData));
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  sectionsByCategoryAndChannelId(categoryId, startIndex, lastIndex) {
    let body = new URLSearchParams();
    body.set('start_index', startIndex);
    body.set('last_index', lastIndex);
    body.set('category_id', categoryId);
    return this.universalApi.postFormWithStatusCheck(URLS.getSectionContentById, body.toString()).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  getWebSearch(type:string, value:string){
    const requestBody = {
      "type": type,
      "value": value,
      "contentSubType": "2"
    }

    return this.universalApi.post(URLS.webSearch,requestBody).pipe(
      catchError(errRes => {
        return throwError(errRes);
      })
    )
  }

  set updateDownLoadVideosList(id: string) {
    this.downloadedVideos.push(id);
  }

  get fetchDownloadedVideosList() {
    return this.downloadedVideos;
  }

  getCCPrimeChannels(): Observable<any[]> {
    var userId: String;
    userId = localStorage.getItem("userId");
    const bodyReq = { 'userId': userId };
    const url = `${URLS.getAllChannelInfo}`;
    return this.universalApi.post(url, bodyReq).pipe(
      map(response => {
        if (response && response.reasonCode === 'OK' && response.responseDto) {
          const channels = response.responseDto.filter(channel => {
            return channel.channelCategory === 'CC_PRIME';
          });
          return channels;
        } else {
          console.error('Invalid or incomplete response format for CC_PRIME channels:', response);
          return [];
        }
      }),
      catchError(errorRes => {
        console.error('Error fetching CC_PRIME channels:', errorRes);
        return of([]);
      })
    );
  }

  getPrimeChannels(): Observable<any[]> {
    var userId: String;
    userId = localStorage.getItem("userId");
    const bodyReq = { 'userId': userId };
    const url = `${URLS.getAllChannelInfo}`;
    return this.universalApi.post(url, bodyReq).pipe(
      map(response => {
        if (response && response.reasonCode === 'OK' && response.responseDto) {
          const channels = response.responseDto.filter(channel => {
            return channel.channelCategory === 'PRIME';
          });
          return channels;
        } else {
          console.error('Invalid or incomplete response format for PRIME channels:', response);
          return [];
        }
      }),
      catchError(errorRes => {
        console.error('Error fetching PRIME channels:', errorRes);
        return of([]);
      })
    );
  }

  calculateModifiedDate(createdAt: string): string {
    const createdDate = new Date(createdAt);
    const currentDate = new Date();
    if (
      createdDate.getDate() === currentDate.getDate() &&
      createdDate.getMonth() === currentDate.getMonth() &&
      createdDate.getFullYear() === currentDate.getFullYear()
    ) {
      return 'Today';
    }
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    if (
      createdDate.getDate() === yesterday.getDate() &&
      createdDate.getMonth() === yesterday.getMonth() &&
      createdDate.getFullYear() === yesterday.getFullYear()
    ) {
      return 'Yesterday';
    }
    const timeDifference = currentDate.getTime() - createdDate.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    if (daysDifference < 30) {
      return `${daysDifference} days ago`;
    } else if (daysDifference < 365) {
      const monthsDifference = Math.floor(daysDifference / 30);
      return `${monthsDifference} months ago`;
    } else {
      const yearsDifference = Math.floor(daysDifference / 365);
      return `${yearsDifference} years ago`;
    }
  }

  getChannelData() {
    const storedData = localStorage.getItem('channelData');
    let channelData;
    if (storedData) {
      try {
        channelData = JSON.parse(storedData);
      } catch (error) {
        console.error('Error parsing stored data:', error);
        channelData = [];
      }
    } else {
      console.warn('No stored data found.');
      channelData = [];
    }
    return channelData;
  }

  isUserFollowingChannel(channelId: any): boolean {
    const channelData = this.getChannelData();
    const channel = channelData.find((c: any) => c.channelId == channelId);
    return channel ? channel.isUserFollowedChannel : false;
  }

  // channelData(channelId: any): any {
  //   const channelData = this.getChannelData();
  //   const channel = channelData.find((c: any) => c.channelId == channelId);
  //   return channel;
  // }

  channelData(channelId:any){
    const requestBody = {
      'channelId': channelId
    }

    return this.http.post(URLS.getChannelData, requestBody);
  }

  channelPlans(channelId: any): any {
    const channelData = this.getChannelData();
    const channel = channelData.find((c: any) => c.channelId == channelId);
    return channel ? channel.availableSubscriptionPlans : null;
  }

  getChannelFollowers(channelId: any): string {
    const channelData = this.getChannelData();
    const channel = channelData.find((c: any) => c.channelId == channelId);
    return channel ? channel.channelFollowerCount : '0';
  }

  likeDislikeContent(vidLibId: string, userId: string, status: string): Observable<any> {
    const url = `${URLS.setUserStatus}?vid_lib_id=${vidLibId}&tqr_user_id=${userId}&status=${status}`;
    
    return this.universalApi.post(url, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        console.error('Error in like/dislike:', error);
        throw error;
      })
    );
  }

  getUserLikedVideos(): Observable<any> {
    if (this.authService.isGuest()) {
      return of({ user_likes: [] });
    }
    return this.universalApi.post(URLS.userLikedVideos, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(error => {
        console.error('Error fetching user liked videos:', error);
        throw error;
      })
    );
  }

  isVideoLikedByUser(vidLibId: string): Observable<boolean> {
    return this.getUserLikedVideos().pipe(
      map(result => {
        if (result && result.user_likes) {
          return result.user_likes.includes(parseInt(vidLibId));
        }
        return false;
      }),
      catchError(error => {
        console.error('Error checking if video is liked:', error);
        return [false]; 
      })
    );
  }
}